import React, { useEffect, useState } from "react";
import { api, formatPrice } from "../../lib/api";
import { PageHead } from "../../components/admin/AdminBits";
import { Truck, CreditCard, Save } from "lucide-react";
import { toast } from "sonner";

export default function AdminPayments() {
  const [s, setS] = useState(null);
  const [orders, setOrders] = useState([]);
  useEffect(() => {
    api.get("/admin/settings").then(({ data }) => setS(data));
    api.get("/admin/orders").then(({ data }) => setOrders(data));
  }, []);

  const save = async () => {
    try { await api.put("/admin/settings", { cod_enabled: s.cod_enabled, card_enabled: s.card_enabled, stripe_enabled: s.stripe_enabled }); toast.success("Запазено"); }
    catch { toast.error("Грешка"); }
  };

  const cod = orders.filter((o) => o.payment_method === "cod");
  const card = orders.filter((o) => o.payment_method === "card");

  if (!s) return <p className="text-charcoal/50">Зареждане...</p>;

  return (
    <div data-testid="admin-payments">
      <PageHead title="Плащания" desc="Управление на методите на плащане и преглед на транзакциите." />
      <div className="grid md:grid-cols-2 gap-5 mb-8">
        <div className="bg-white border border-stone p-6">
          <h2 className="font-serif text-xl text-navy mb-4">Активни методи</h2>
          <label className="flex items-center gap-3 text-sm text-navy mb-3"><input type="checkbox" checked={s.cod_enabled !== false} onChange={(e) => setS({ ...s, cod_enabled: e.target.checked })} className="accent-[#C6A45C] w-4 h-4" data-testid="pay-cod" /><Truck size={16} className="text-gold" /> Наложен платеж</label>
          <label className="flex items-center gap-3 text-sm text-navy mb-3"><input type="checkbox" checked={!!s.card_enabled} onChange={(e) => setS({ ...s, card_enabled: e.target.checked })} className="accent-[#C6A45C] w-4 h-4" data-testid="pay-card" /><CreditCard size={16} className="text-gold" /> Плащане с карта</label>
          <p className="text-xs text-charcoal/45 mb-4">За реално таксуване с карта чрез Stripe е нужно да добавите API ключове (свържете се за активиране).</p>
          <button onClick={save} className="btn-gold px-5 py-2.5 rounded-sm flex items-center gap-2 text-sm" data-testid="save-payments-btn"><Save size={15} /> Запази</button>
        </div>
        <div className="bg-white border border-stone p-6">
          <h2 className="font-serif text-xl text-navy mb-4">Обобщение</h2>
          <div className="flex justify-between py-2 border-b border-stone"><span className="text-charcoal/60 text-sm flex items-center gap-2"><Truck size={15} className="text-gold" /> Наложен платеж</span><span className="text-navy font-medium">{cod.length} поръчки</span></div>
          <div className="flex justify-between py-2 border-b border-stone"><span className="text-charcoal/60 text-sm flex items-center gap-2"><CreditCard size={15} className="text-gold" /> Карта</span><span className="text-navy font-medium">{card.length} поръчки</span></div>
          <div className="flex justify-between py-3"><span className="text-navy font-serif">Общо приходи</span><span className="text-navy font-serif">{formatPrice(orders.reduce((a, o) => a + (o.total || 0), 0))}</span></div>
        </div>
      </div>
    </div>
  );
}
